import { BrokerPatientUpdateMissingData, GetBrokerMissingData } from "@/api/endpoints";
import { ColumnsGenerator } from "@/utils/tableUtils";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ReportContent, ReportHeader, ReportSearch } from "@/components/tableDrawer";
import ActionBtn from "@/pages/accountManager/medical/shared/ActionBtn/ActionBtn";
import UploadPatientMedicalFiles from "@/components/popups/UploadPatientMedicalFiles";
import { CRRender } from "@/components/crRender";
import BrokerMissingPopup from "@/pages/broker/clients/patientList/Components/Popups/BrokerMissingPopup";
import AddPatientPopup from "@/pages/broker/clients/patientList/Components/Popups/AddPatientPopup";

const RequestMissingData = () => {
  const { state: params } = useLocation();
  const { t } = useTranslation();
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientId, setSelectedPatientId] = useState(null);
  const missingDataRef = useRef(null);
  const refUploadPatientMedicalFilesModal = useRef(null);
    const addPatientModalRef = useRef(null)

  const openPopup = (data) => {
    setSelectedPatient(data);
    setSelectedPatientId(data?.patientId);
    missingDataRef.current.click();
  };

  const columns = [
    ColumnsGenerator.CustomCell("ID", (original) => `#${original?.patientId}`),
    ColumnsGenerator.CustomCell("patient-name", (original) => `${original?.firstName} ${original?.lastName}`),
    ColumnsGenerator.CustomCell("groupName", (original) => `${original?.groupName}`),
    ColumnsGenerator.CustomCell("missingDataMsg", (original) => <div className="text-truncate" style={{ maxWidth: "200px" }} title={original?.missingDataMsg}>
      {original?.missingDataMsg}
    </div>),
    ColumnsGenerator.CustomCell("action", (original) => (
      <div className="broker-actions">
        <ActionBtn onClick={() => openPopup(original)} className="missing-data" tooltipName={"fill-missing-data"} icon={"akar-icons:question-fill"} />
        <ActionBtn onClick={() => viewRequestDetails(original)} title="show-details" tooltipName={"show-details"} className="details-info" icon={"fluent:eye-16-filled"} />
        <ActionBtn onClick={() => editPatient(original)} title="edit" className="medical-files-info" icon={"boxicons:edit"} />
      </div>
    )),
  ];


    const editPatient = (original) => {
      setSelectedPatient(original);
      setSelectedPatientId(original?.patientId)
      addPatientModalRef?.current?.click()
    }

  useEffect(() => {
    if (params && params?.patient) {
      openPopup(params?.patient)}
  }, [params]);

  return (
    <>
      <BrokerMissingPopup title={t("patient-missing-data")} name={`broker-missing-popup`} modalID={missingDataRef} patient={selectedPatient} refUploadPatientMedicalFilesModal={refUploadPatientMedicalFilesModal} 
      addPatientModalRef={addPatientModalRef} setSelectedPatient={setSelectedPatient}
      />
      <UploadPatientMedicalFiles patientId={patientId} setSelectedPatientId={setSelectedPatientId} modalID={refUploadPatientMedicalFilesModal} apiCall={(data) => BrokerPatientUpdateMissingData(data.patientId, {attachmentIds: data.attachmentIds})} />
      <CRRender isRender={!!patientId && !!selectedPatient}>
        <AddPatientPopup modalId={addPatientModalRef} patientId={patientId} selectedPatient={selectedPatient}  />
      </CRRender>

      <ReportContent tableAPI={GetBrokerMissingData} columns={columns}>
        <ReportHeader>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
    </>
  );
};

export default RequestMissingData;
